import { ReactComponent as InputSearchIcon } from '../../../assets/search-icon.svg'

export const SearchIcon = () => (
    <InputSearchIcon height="40" />
)
